var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5405_51046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8997 21H8.0985C5.0484 21 3 18.8598 3 15.6756V8.3244C3 5.1402 5.0484 3 8.0985 3H15.9006C18.9507 3 21 5.1402 21 8.3244V15.6756C21 18.8598 18.9507 21 15.8997 21V21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8997 21H8.0985C5.0484 21 3 18.8598 3 15.6756V8.3244C3 5.1402 5.0484 3 8.0985 3H15.9006C18.9507 3 21 5.1402 21 8.3244V15.6756C21 18.8598 18.9507 21 15.8997 21V21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 20H8.0985V22H15.8997V20ZM8.0985 20C6.81612 20 5.81267 19.5556 5.12777 18.8403C4.43924 18.1212 4 17.0513 4 15.6756H2C2 17.4841 2.58496 19.0764 3.68315 20.2234C4.78498 21.3743 6.33077 22 8.0985 22V20ZM4 15.6756V8.3244H2V15.6756H4ZM4 8.3244C4 6.94875 4.43924 5.87884 5.12777 5.15969C5.81266 4.44436 6.81612 4 8.0985 4V2C6.33078 2 4.78498 2.62574 3.68315 3.77656C2.58496 4.92356 2 6.51585 2 8.3244H4ZM8.0985 4H15.9006V2H8.0985V4ZM15.9006 4C17.183 4 18.1867 4.44437 18.8719 5.15978C19.5606 5.87897 20 6.94887 20 8.3244H22C22 6.51573 21.4147 4.92343 20.3163 3.77647C19.2143 2.62573 17.6683 2 15.9006 2V4ZM20 8.3244V15.6756H22V8.3244H20ZM20 15.6756C20 17.0511 19.5606 18.121 18.8718 18.8402C18.1866 19.5556 17.1826 20 15.8997 20V22C17.6678 22 19.214 21.3743 20.3162 20.2236C21.4147 19.0766 22 17.4843 22 15.6756H20Z",
    fill: "#CED0D9",
    mask: "url(#path-1-inside-1_5405_51046)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.37a93bf71d4f3973dada0f1e22fcd795.svg";
export { ForwardRef as ReactComponent };